import h from "../core/createElement"
import Btn from "./btn";

export default function GroupCard({ data: { name, id, can_be_deleted }, deleteClick }) {
    return (
        <article class="card">
            <div class="top">
                <span class="title">{name}</span>
                {can_be_deleted ? <Btn icon="assets/image/trash.svg" color="red" onClick={() => deleteClick && deleteClick({ name, id })} /> : ""}
            </div>
        </article>
    );
};